import React from 'react';
import { Icon } from 'components/icon';
import { TooltipMUIConditionalWrapper } from 'components/tooltip';
import { colors } from 'constants/styles';
const PaymentMethodDetailItemAction = React.forwardRef(({ icon, onClick, tooltipTitle }, ref) => (React.createElement("span", { className: "payment_method__detail-item-action-icon", onClick: onClick, ref: ref, role: "presentation" },
    React.createElement(TooltipMUIConditionalWrapper, { tooltipProps: { title: tooltipTitle } },
        React.createElement(Icon, { color: colors.colorGreyXXDarkHex, icon: icon })))));
export default PaymentMethodDetailItemAction;
